import { getPostcodeArea } from '@utils/postcode-validation';
import { rooferCategoryIds } from './categories/roofer';
import { surveyingCategoryIds } from './categories/surveying';

export const bannerCategories = new Set([
  ...rooferCategoryIds,
  ...surveyingCategoryIds,
]);
export const bannerCodeAreas = new Set(['OX', 'RG']);

export const showCheckaroofBanner = (postcode: string, categoryId: number) => {
  const postcodeArea = getPostcodeArea(postcode) || postcode;
  return (
    bannerCategories.has(categoryId) &&
    bannerCodeAreas.has(postcodeArea.toUpperCase())
  );
};
